import { render, staticRenderFns } from "./IntensiveCareDeliriumScreeningScale.vue?vue&type=template&id=926c4208&scoped=true"
import script from "./IntensiveCareDeliriumScreeningScale.vue?vue&type=script&lang=js"
export * from "./IntensiveCareDeliriumScreeningScale.vue?vue&type=script&lang=js"
import style0 from "./IntensiveCareDeliriumScreeningScale.vue?vue&type=style&index=0&id=926c4208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926c4208",
  null
  
)

export default component.exports